import React from 'react';
import { Reveal } from './Reveal';
const withoutItems = ['😓 References scattered across dozens of websites and half-finished courses', '🔁 Winging sessions with no structured professional foundation', '💭 Searching your phone mid-session for answers you should already have', '😰 Knowledge fragmented across 6 different disciplines with no system connecting them', '🌑 A practice that feels incomplete and never reaches its full potential', '😩 Energy depletion and burnout from absorbing client energy', '💸 Charging 50% of what you should because you don’t feel professional'];
const withItems = ['📖 One complete professional library — always at your fingertips', '🎯 Every session backed by a complete, organized reference system', '💪 Confident, professional answers backed by real structured knowledge', '🌙 All 6 disciplines connected in one coherent, integrated framework', '✨ A practice that looks, feels, and performs completely professional', '🛡️ Protected and grounded—no more energy depletion', '💰 Confidence to charge premium prices and attract ideal clients'];
type PanelProps = {
  title: string;
  label: string;
  items: string[];
  positive?: boolean;
};
function Panel({
  title,
  label,
  items,
  positive
}: PanelProps) {
  return <div className={`p-7 sm:p-10 ${positive ? 'bg-surface' : 'bg-mist'}`} data-id="element-28" data-mp="189kj3rs3hldn">
      <p className={`text-xs font-bold uppercase tracking-[0.16em] ${positive ? 'text-sage' : 'text-red-500'}`} data-id="element-29" data-mp="1877voz3kiit7">
        {label}
      </p>
      <h3 className="mt-4 font-serif text-3xl leading-tight text-navy" data-id="element-30" data-mp="20yho4t7aplog">{title}</h3>
      <ul className="mt-7 divide-y divide-navy/10" data-id="element-31" data-mp="1vxtxi8mzb6ur">
        {items.map(item => <li key={item} className="py-4 text-sm leading-relaxed text-slate sm:text-base" data-id="element-32" data-mp="1r0lek5u0aysg">
            {item}
          </li>)}
      </ul>
    </div>;
}
export function Comparison() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-33" data-mp="fkdj0oczsnqa">
      <div className="mx-auto max-w-6xl" data-id="element-34" data-mp="h1sqryp6f5ic">
        <Reveal className="mx-auto max-w-3xl text-center" data-id="element-35" data-mp="h2vi27qev9ys">
          <h2 className="font-serif text-4xl text-navy sm:text-5xl" data-id="element-36" data-mp="m0wwuggt0n4g">
            ⚖️ The Difference a <span className="text-sage" data-id="element-37" data-mp="lyj3cc1rviz0">Real System</span> Makes
          </h2>
          <p className="mt-5 text-slate" data-id="element-38" data-mp="80un5hinh00a">
            You’re not buying files. You’re buying a complete therapeutic tarot operating system.
          </p>
        </Reveal>
        <Reveal delay={0.08} data-id="element-39" data-mp="3ufnnmqpju276">
          <div className="mt-10 overflow-hidden rounded-2xl border border-navy/10 shadow-elevated md:grid md:grid-cols-2" data-id="element-40" data-mp="3uem2ftetjzbq">
            <Panel label="❌ WITHOUT" title="Without Therapeutic Tarot Guide™" items={withoutItems} data-id="element-41" data-mp="3lg0pqew13eiv" />
            <Panel positive label="✅ WITH" title="With Therapeutic Tarot Guide™" items={withItems} data-id="element-42" data-mp="3pi5ep0bj7mz6" />
          </div>
        </Reveal>
      </div>
    </section>;
}